import React, { useState } from "react";
import { Col, Row, Button, Form, message } from "antd";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
// component
import PaymentEmail from "./component/payment_email";
import PaymentFirstName from "./component/payment_first_name";
import PaymentLastName from "./component/payment_last_name";
import PaymentDOB from "./component/payment_dob";
import PaymentGender from "./component/payment_gender";
import PaymentAddress from "./component/payment_address";
import PaymentAddressCity from "./component/payment_address_city";
import PaymentAddressState from "./component/payment_address_state";
import PaymentAddressSuburb from "./component/payment_address_suburb";
import PaymentAddressPostCode from "./component/payment_address_post_code";
import PaymentDescription from "./component/payment_description";
import PaymentDocumentFront from "./component/payment_document_front";
import PaymentDocumentBack from "./component/payment_document_back";
import PaymentAdditionalDocumentFront from "./component/payment_additional_document_front";
import PaymentAdditionalDocumentBack from "./component/payment_additional_document_back";
import PaymentPhone from "./component/payment_phone";
// redux
import { createAccount } from "../../store/stripe/stripe.action";

const BranchPaymentRegister = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const params = useParams();
  const branch = params?.id;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const disabled = loading;
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    setLoading(true);
    const day = parseInt(moment(values.dob).format("DD"));
    const month = parseInt(moment(values.dob).format("MM"));
    const year = parseInt(moment(values.dob).format("YYYY"));
    const { docBack, docFront, addDocFront, addDocBack, ...data } = values;
    const verification = danDanLongLong({
      docFront,
      docBack,
      addDocFront,
      addDocBack,
    });

    const accountData = {
      ...data,
      verification,
      dob: { day, month, year },
      branch,
    };
    dispatch(
      createAccount({ accountData }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Submit successfully!");
        } else {
          const error = response?.data?.raw?.message;
          console.log({ error: response?.data?.raw });
          message.error(error);
        }
      })
    );
  };

  const onFinishFailed = (values) => {
    console.log({ failed: values });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    return (
      <Form
        name="payment_form"
        autoComplete="off"
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <PaymentEmail disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentFirstName disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentLastName disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentDOB disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentGender disabled={disabled} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <PaymentAddress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressCity disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressState disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressSuburb disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressPostCode disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentDescription disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentPhone disabled={disabled} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <p>Identify Document (Passport)</p>
            <Row gutter={[16, 0]}>
              <Col>
                <PaymentDocumentFront disabled={disabled} />
              </Col>
              <Col>
                <PaymentDocumentBack disabled={disabled} />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <p>Address Document (Utility Bill)</p>
            <Row gutter={[16, 0]}>
              <Col>
                <PaymentAdditionalDocumentFront disabled={disabled} />
              </Col>
              <Col>
                <PaymentAdditionalDocumentBack disabled={disabled} />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button form-button"
              style={{ width: "100%", marginBottom: 10 }}
              loading={loading}
            >
              Verify Stripe Account
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 12]} style={{ borderRight: "0.5px solid #ccc" }}>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

export default BranchPaymentRegister;

const danDanLongLong = ({ docFront, docBack, addDocFront, addDocBack }) => {
  const hasDocument = docFront || docBack;
  const document = {
    ...(docFront && { front: docFront }),
    ...(docBack && { back: docBack }),
  };
  const hasAddDocument = addDocFront || addDocBack;
  const additional_document = {
    ...(addDocFront && { front: addDocFront }),
    ...(addDocBack && { back: addDocBack }),
  };
  const hasVerrification = hasDocument || hasAddDocument;
  const verification = {
    ...(hasDocument && { document }),
    ...(hasAddDocument && { additional_document }),
  };
  return hasVerrification && verification;
};
